import confetti from 'canvas-confetti';

export function useConfetti() {
  function fireworks({duration = 5000} = {}) {
    const animationEnd = Date.now() + duration;
    const defaults = {startVelocity: 30, spread: 500, zIndex: 0};

    function randomInRange (min, max) {
      return Math.random() * (max - min) + min;
    }

    const interval = setInterval(function() {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const particleCount = 75 * (timeLeft / duration);
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.5 } });
      confetti({ ...defaults, particleCount, origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.5 } });
    }, 250);
  }

  return {
    fireworks
  };
}
